import { useCallback, useMemo } from 'react';
import {
  clearStoredEmail as clearStoredEmailFromStorage,
  getStoredEmail as getStoredEmailFromStorage,
  setStoredEmail as setStoredEmailToStorage,
} from '../../browser/storage';

/**
 * Hook for managing email persistence in localStorage
 * Used to prefill email fields for returning users
 */
export const useEmailStorage = () => {
  /**
   * Retrieve stored email from localStorage
   */
  const getStoredEmail = useCallback((): string | null => {
    return getStoredEmailFromStorage();
  }, []);

  /**
   * Save email to localStorage for future prefilling
   */
  const setStoredEmail = useCallback((email: string): void => {
    setStoredEmailToStorage(email);
  }, []);

  /**
   * Clear stored email from localStorage
   */
  const clearStoredEmail = useCallback((): void => {
    clearStoredEmailFromStorage();
  }, []);

  return useMemo(
    () => ({
      getStoredEmail,
      setStoredEmail,
      clearStoredEmail,
    }),
    [getStoredEmail, setStoredEmail, clearStoredEmail]
  );
};
